import React from "react";
import { useStealthMode } from "../context/StealthModeContext";
import defaultImage from '../images/default.jpg'

export default function SafeMedia({
  src,
  srcSet,
  sizes,
  alt = "",
  placeholder = "images/stealth-hide.png",
  ...rest
}) {

  const { enabled } = useStealthMode();

  if (enabled) {
    return <img src={placeholder || defaultImage} alt={alt ? `${alt} (hidden)` : "Hidden for stealth mode"} {...rest} />;
  }

  const isVideo = src && (src.includes(".mp4") || src.includes(".webm"));

  if (isVideo) {
    return <video src={src } {...rest} autoPlay muted loop />;
  }

  return <img src={src || defaultImage} srcSet={srcSet} sizes={sizes} alt={alt} {...rest} />;
} 